import { useState, useEffect } from 'react';

const useInput = (validateValue, defaultValue) => {
	const [enteredValue, setEnteredValue] =
		useState(defaultValue);
	const [isTouched, setIsTouched] = useState(
		!!defaultValue
	);
	useEffect(() => {
		if (defaultValue && defaultValue !== enteredValue) {
			setEnteredValue(defaultValue);
			setIsTouched(!!defaultValue);
		}
	}, [validateValue]);

	const valueIsValid =
		enteredValue && validateValue(enteredValue);
	const hasError = !valueIsValid && isTouched;

	const valueChangeHandler = (event) => {
		if (!!event.length) {
			return setEnteredValue(event);
		}
		setEnteredValue(event.target.value);
	};

	const inputBlurHandler = (event) => {
		setIsTouched(true);
	};

	const reset = () => {
		setEnteredValue('');
		setIsTouched(false);
	};

	return {
		value: enteredValue,
		isValid: valueIsValid,
		hasError,
		valueChangeHandler,
		inputBlurHandler,
		reset
	};
};

export default useInput;
